import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AttendanceKioskScreen } from '@/features/attendance-kiosk/kiosk-screen'

export const Route = createFileRoute('/kiosk')({
  component: AttendanceKioskRoute,
})

function AttendanceKioskRoute() {
  const navigate = useNavigate()
  return (
    <AttendanceKioskScreen
      onNavigateDiagnostics={() => void navigate({ to: '/face-diagnostics' })}
    />
  )
}
